/**
 * Libellés FR utilisés par l'admin pour afficher les sections / items du
 * configurateur (l'app cliente utilise i18n via `titleKey` / `labelKey`).
 * Ce fichier mappe ces clés vers une chaîne lisible.
 */

export const SECTION_LABELS: Record<string, string> = {
    'visibleSections.group.products': 'Produits disponibles',
    'visibleSections.group.shirtConfiguration': 'Chemise vendue seule',
    'visibleSections.group.standaloneVestConfiguration': 'Gilet vendu seul',
    'configurator.product.suit': 'Costume',
    'configurator.product.suitSubtitle': 'Autoriser la configuration et la commande de costumes',
    'configurator.product.shirt': 'Chemise',
    'configurator.product.shirtSubtitle': 'Autoriser la configuration et la commande de chemises seules',
    'configurator.product.vest': 'Gilet',
    'configurator.product.vestSubtitle': 'Autoriser la configuration et la commande de gilets seuls',
    'configurator.shirt.style': 'Modèle de chemise',
    'configurator.shirt.styleSubtitle': 'Choisissez entre les deux modèles actuellement disponibles',
    'configurator.shirt.fabric': 'Tissu de chemise',
    'configurator.shirt.fabricSubtitle': 'Références de la liasse chemise F416',
    'configurator.vest.cut': 'Coupe du gilet',
    'configurator.vest.cutSubtitle': 'Forme et nombre de boutons du gilet vendu seul',
    'configurator.vest.buttons': 'Boutons du gilet',
    'configurator.vest.buttonsSubtitle': 'Choix des boutons du gilet',
    'configurator.vest.fabric': 'Tissu du gilet',
    'configurator.vest.fabricSubtitle': 'Choix de la liasse et de la référence de tissu',
    'configurator.vest.pockets': 'Poches du gilet',
    'configurator.vest.pocketsSubtitle': 'Style des poches du gilet vendu seul',
    'configurator.vest.lapels': 'Revers du gilet',
    'configurator.vest.lapelsSubtitle': 'Style et largeur du revers du gilet vendu seul',
    'configurator.vest.back': 'Arrière du gilet',
    'configurator.vest.backSubtitle': 'Finition de l’arrière du gilet vendu seul',
    'configurator.vest.contrast': 'Contrastes du gilet',
    'configurator.vest.contrastSubtitle': 'Emplacements des contrastes du gilet vendu seul',
    'configurator.vest.buttonhole': 'Boutonnière du gilet',
    'configurator.vest.buttonholeSubtitle': 'Couleur du fil de la boutonnière du gilet vendu seul',
    'configurator.vest.embroidery': 'Broderie du gilet',
    'configurator.vest.embroiderySubtitle': 'Activer et personnaliser la broderie du gilet vendu seul',
    'configurator.perso.jacketLining': 'Doublure de la veste',
    'configurator.perso.jacketLiningSubtitle': 'Choisissez une référence de doublure pour la veste',
    'configurator.perso.pantsLiningFabric': 'Référence de doublure du pantalon',
    'configurator.perso.pantsLiningFabricSubtitle': 'Choisissez une référence de doublure pour le pantalon',
    'visibleSections.group.coupe': 'Coupe',
    'visibleSections.group.jacketPersonalization': 'Personnalisation veste',
    'visibleSections.group.vestPersonalization': 'Personnalisation gilet',
    'visibleSections.group.pantsPersonalization': 'Personnalisation pantalon',
    'visibleSections.group.embroidery': 'Broderie',

    'configurator.coupe.suitType': 'Type de costume',
    'configurator.coupe.jacketCut': 'Coupe veste',
    'configurator.coupe.pantsCut': 'Coupe pantalon',
    'configurator.coupe.addVest': 'Ajouter un gilet',
    'configurator.coupe.vestFabric': 'Tissu du gilet',
    'configurator.coupe.vestBackFabric': 'Dos du gilet',
    'configurator.coupe.vestBackFabricSubtitle': 'Choisissez le tissu ou la doublure du dos du gilet',
    'configurator.coupe.pantsFabric': 'Tissu du pantalon',

    'configurator.perso.chemise': 'Chemise',
    'configurator.perso.colType': 'Type de col',
    'configurator.perso.chestPocket': 'Poche poitrine',
    'configurator.perso.lowerPockets': 'Poches basses',
    'configurator.perso.sleeveCap': 'Tête de manche',
    'configurator.perso.backVents': 'Fentes arrière',
    'configurator.perso.buttons': 'Boutons',
    'configurator.perso.topstitch': 'Surpiqûre',
    'configurator.perso.collarButtonhole': 'Boutonnière col',
    'configurator.perso.sleeveOpening': 'Ouverture manche',
    'configurator.perso.sleeveButtons': 'Boutons manche',
    'configurator.perso.jacketContrast': 'Contraste veste',
    'configurator.perso.construction': 'Construction',
    'configurator.perso.interiorStyle': 'Style intérieur',
    'configurator.perso.collarFelt': 'Feutre de col',

    'configurator.perso.vestPockets': 'Poches gilet',
    'configurator.perso.vestLapels': 'Revers gilet',
    'configurator.perso.vestBack': 'Arrière gilet',
    'configurator.perso.vestContrast': 'Contraste gilet',

    'configurator.perso.cornerPocket': 'Poche coin',
    'configurator.perso.backPocket': 'Poche arrière',
    'configurator.perso.pantsBottom': 'Bas de pantalon',
    'configurator.perso.pantsLining': 'Doublure pantalon',
    'configurator.perso.pantsButtons': 'Bouton pantalon',
    'configurator.perso.pantsContrast': 'Contraste pantalon',

    'configurator.perso.embroidery': 'Broderie',
    'configurator.coupe.buttonholeColor': 'Couleur de boutonnière',
    'configurator.coupe.waistHeight': 'Hauteur de taille',
    'configurator.perso.collarWidth': 'Largeur du col',
    'configurator.perso.topstitchColor': 'Couleur de la surpiqûre',
    'configurator.perso.buttonholeColor': 'Couleur de boutonnière',
    'configurator.perso.sleeveNumber': 'Nombre de boutons de manche',
    'configurator.perso.sleeveOverlappingQuestion': 'Boutons de manche chevauchés',
    'configurator.perso.sleeveOrientation': 'Orientation des boutons de manche',
    'configurator.perso.sleeveButtonholePosition': 'Position de la boutonnière de manche',
    'configurator.perso.lapelSize': 'Dimension du revers',
    'configurator.perso.embroideryJacketPosition': 'Position de broderie veste',
    'configurator.perso.embroideryTarget': 'Pièce à broder',
    'configurator.perso.embroideryVestPosition': 'Position broderie gilet',
    'configurator.perso.embroideryUseSameSettings': 'Même réglage de broderie',
    'configurator.perso.embroideryPantsPosition': 'Position de broderie pantalon',
    'configurator.perso.embroideryThread': 'Fil de broderie',
    'configurator.perso.embroiderySize': 'Taille de broderie',
    'configurator.perso.embroideryFont': 'Police de broderie',
};

export const ITEM_LABELS: Record<string, string> = {
    'configurator.option.suitPiece.2pieces': '2 pièces',
    'configurator.option.suitPiece.3pieces': '3 pièces',

    'configurator.option.jacketCut.1bouton': '1 bouton',
    'configurator.option.jacketCut.2boutons': '2 boutons',
    'configurator.option.jacketCut.croise4x2': 'Croisé 4x2',
    'configurator.option.jacketCut.croise6x2': 'Croisé 6x2',
    'configurator.option.jacketCut.3boutons': '3 boutons',
    'configurator.option.jacketCut.3x2boutons': '3x2 boutons',
    'configurator.option.jacketCut.croise4x1': 'Croisé 4x1',
    'configurator.option.jacketCut.croise6x1': 'Croisé 6x1',

    'configurator.option.pantalon.sansPince': 'Sans pince',
    'configurator.option.pantalon.1pince': '1 pince',
    'configurator.option.pantalon.2pinces': '2 pinces',

    'configurator.option.vestType.3boutons': '3 boutons',
    'configurator.option.vestType.4boutons': '4 boutons',
    'configurator.option.vestType.5boutons': '5 boutons',
    'configurator.option.vestType.6boutons': '6 boutons',
    'configurator.option.vestType.5x3InclinePointu': '5x3 incliné pointu',
    'configurator.option.vestType.carre6x3': 'Carré 6x3',
    'configurator.option.vestType.carre8x4': 'Carré 8x4',
    'configurator.option.vestType.croise6x3': 'Croisé 6x3',
    'configurator.option.vestType.croise8x4': 'Croisé 8x4',

    'configurator.coupe.sameFabric': 'Même tissu',
    'configurator.coupe.differentFabric': 'Tissu différent',

    'configurator.option.chemise.chemise1': 'Chemise 1',
    'configurator.option.chemise.chemise2': 'Chemise 2',

    'configurator.option.colType.colACran': 'Col à cran',
    'configurator.option.colType.colChale': 'Col châle',
    'configurator.option.colType.colChaleArrondi': 'Col châle arrondi',
    'configurator.option.colType.colChaleFin': 'Col châle fin',
    'configurator.option.colType.colEnArc': 'Col en arc',
    'configurator.option.colType.colEnPointe': 'Col en pointe',

    'configurator.option.pochette.sans': 'Sans',
    'configurator.option.pochette.standard': 'Standard',
    'configurator.option.pochette.bateau': 'Bateau',
    'configurator.option.pochette.correctif': 'Correctif',
    'configurator.option.pochette.safari': 'Safari',

    'configurator.option.stylePoche.standard': 'Standard',
    'configurator.option.stylePoche.flapFlap': 'Flap & flap',
    'configurator.option.stylePoche.rabatDoubleBalai': 'Rabat et double balai',
    'configurator.option.stylePoche.correctif': 'Correctif',
    'configurator.option.stylePoche.doubleBalai': 'Double balai',
    'configurator.option.stylePoche.bateau': 'Bateau',
    'configurator.option.stylePoche.rabatIncline': 'Rabat incliné',
    'configurator.option.stylePoche.rabatInclineDoubleBalai': 'Rabat incliné et double balai',
    'configurator.option.stylePoche.safari': 'Safari',
    'configurator.option.stylePoche.uknow': 'Uknow',
    'configurator.option.stylePoche.patch': 'Patch',
    'configurator.option.stylePoche.safari2': 'Safari 2',

    'configurator.option.teteDeManche.standard': 'Standard',
    'configurator.option.teteDeManche.bateau': 'Bateau',
    'configurator.option.teteDeManche.correctif': 'Napolitain',
    'configurator.option.teteDeManche.safari': 'Big Napolitain',

    'configurator.option.fenteArriere.fermee': 'Fermée',
    'configurator.option.fenteArriere.1fente': '1 fente',
    'configurator.option.fenteArriere.2fentes': '2 fentes',

    'configurator.option.button.default': 'Par défaut',

    'configurator.option.surpiqure.sans': 'Sans',
    'configurator.option.surpiqure.02cm': '0,2 cm',
    'configurator.option.surpiqure.06cm': '0,6 cm',

    'configurator.option.boutonniereCol.sans': 'Sans',
    'configurator.option.boutonniereCol.arrondi': 'Arrondi',
    'configurator.option.boutonniereCol.droit': 'Droit',

    'configurator.option.ouvertureManche.fonctionnel': 'Fonctionnelle',
    'configurator.option.ouvertureManche.nonFonctionnel': 'Non fonctionnelle',

    'configurator.option.boutonManche.sans': 'Sans',
    'configurator.option.boutonManche.1droit': '1 droit',
    'configurator.option.boutonManche.2droit': '2 droit',
    'configurator.option.boutonManche.3droit': '3 droit',
    'configurator.option.boutonManche.4droit': '4 droit',
    'configurator.option.boutonManche.5droit': '5 droit',
    'configurator.option.boutonManche.1enBiais': '1 en biais',
    'configurator.option.boutonManche.2enBiais': '2 en biais',
    'configurator.option.boutonManche.3enBiais': '3 en biais',
    'configurator.option.boutonManche.4enBiais': '4 en biais',
    'configurator.option.boutonManche.5enBiais': '5 en biais',
    'configurator.option.boutonManche.2chevauchee': '2 chevauchée',
    'configurator.option.boutonManche.3chevauchee': '3 chevauchée',
    'configurator.option.boutonManche.4chevauchee': '4 chevauchée',
    'configurator.option.boutonManche.5chevauchee': '5 chevauchée',
    'configurator.option.boutonManche.2chevaucheeEnBiais': '2 chevauchée en biais',
    'configurator.option.boutonManche.3chevaucheeEnBiais': '3 chevauchée en biais',
    'configurator.option.boutonManche.4chevaucheeEnBiais': '4 chevauchée en biais',
    'configurator.option.boutonManche.5chevaucheeEnBiais': '5 chevauchée en biais',

    'configurator.option.contrasteVeste.col': 'Col',
    'configurator.option.contrasteVeste.colArriere': 'Col arrière',
    'configurator.option.contrasteVeste.boutonAvant': 'Bouton avant',
    'configurator.option.contrasteVeste.boutonManche': 'Bouton manche',
    'configurator.option.contrasteVeste.pocheBasse': 'Poche basse',
    'configurator.option.contrasteVeste.passepoilPoche': 'Passepoil poche basse',
    'configurator.option.contrasteVeste.pochePoitrine': 'Poche poitrine',

    'configurator.option.construction.classique': 'Classique',
    'configurator.option.construction.entoilage': 'Entoilage traditionnel',

    'configurator.option.interiorStyle.sans': 'Sans',
    'configurator.option.interiorStyle.fullLining': 'Doublure complète + parement courbe',
    'configurator.option.interiorStyle.straight': 'Droit',
    'configurator.option.collarFelt.match': 'Match',
    'configurator.option.collarFelt.other': 'Autre',

    'configurator.option.pocheGilet.sans': 'Sans',
    'configurator.option.pocheGilet.passepoilee': 'Passepoilée',
    'configurator.option.pocheGilet.doublePassepoilee': 'Double passepoilée',
    'configurator.option.pocheGilet.passepoileePoitrine': 'Passepoilée + poitrine',
    'configurator.option.pocheGilet.pocheARabat': 'Poche à rabat',

    'configurator.option.reversGilet.sans': 'Sans',
    'configurator.option.reversGilet.aCran': 'À cran',
    'configurator.option.reversGilet.chale': 'Châle',
    'configurator.option.reversGilet.enPointe': 'En pointe',
    'configurator.option.reversGilet.grandU': 'Grand U',
    'configurator.option.reversGilet.u': 'U',

    'configurator.option.arriereGilet.sans': 'Sans',
    'configurator.option.arriereGilet.carre': 'Carré',
    'configurator.option.arriereGilet.pointe': 'Pointe',

    'configurator.option.contrasteGilet.col': 'Col',
    'configurator.option.contrasteGilet.colArriere': 'Col arrière',
    'configurator.option.contrasteGilet.pocheBasse': 'Poche basse',
    'configurator.option.contrasteGilet.pochePoitrine': 'Poche poitrine',

    'configurator.option.pochetteCoin.sans': 'Sans',
    'configurator.option.pochetteCoin.pocheInterrieur': 'Poche intérieure',
    'configurator.option.pochetteCoin.pocheTicket': 'Poche ticket',
    'configurator.option.pochetteCoin.pocheARabat': 'Poche à rabat',

    'configurator.option.pocheArriere.aucun': 'Aucune',
    'configurator.option.pocheArriere.doublePassepoileDroit': 'Double passepoilé droit',
    'configurator.option.pocheArriere.doublePassepoilee': 'Double passepoilée',
    'configurator.option.pocheArriere.doublePassepoileeAvecBouton': 'Double passepoilée avec bouton',
    'configurator.option.pocheArriere.passepoileeAvecBouton': 'Passepoilée avec bouton',
    'configurator.option.pocheArriere.rabat1': 'Rabat 1',
    'configurator.option.pocheArriere.rabat2': 'Rabat 2',
    'configurator.option.pocheArriere.rabatSansBouton': 'Rabat sans bouton',

    'configurator.option.basDePantalon.ourlet': 'Ourlet',
    'configurator.option.basDePantalon.revers': 'Revers',
    'configurator.option.basDePantalon.nonFini': 'Non fini',

    'configurator.option.doublurePantalon.sans': 'Sans',
    'configurator.option.doublurePantalon.avec': 'Avec',

    'configurator.option.contrastePantalon.passepoileePoche': 'Passepoilée poche',
    'configurator.option.contrastePantalon.bandeCote05': 'Bande côté 0,5 cm',
    'configurator.option.contrastePantalon.bandeCote12': 'Bande côté 1,2 cm',
    'configurator.option.contrastePantalon.bandeCote20': 'Bande côté 2,0 cm',
    'configurator.option.contrastePantalon.ceinture': 'Ceinture',
    'configurator.option.contrastePantalon.boutonRecouvert': 'Bouton recouvert',
};

export const labelOf = (key?: string, fallback?: string): string => {
    if (!key) return fallback || '';
    return SECTION_LABELS[key] || ITEM_LABELS[key] || fallback || key;
};
